import Vue from 'vue'
import Vuex from 'vuex'
import lineRichmenuManager from './lineRichmenuManager'
import channelIdManager from './channelIdManager'
import login from './login'
import packagePlan from './packagePlan'
import ssoAccount from './ssoAccount'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { overlay: false },
  mutations: {
    SET_OVERLAY_BOOLEAN(state, payload) {
      state.overlay = payload
    }
  },
  getters: {
    getOverlay(state) {
      return state.overlay
    }
  },
  actions: {
    setOverlay: async function ({ commit }, payload) {
      commit('SET_OVERLAY_BOOLEAN', payload)
    }
  },
  modules: {
    lineRichmenuManager,
    login,
    channelIdManager,
    packagePlan,
    ssoAccount
  }
})
